<template>
  <login-wrap
    id="forgotPswd"
    :title="title"
    :text="text">
    <valid-form
      id="fp-content-block"
      @submit="sendAction">
      <qx-input-row
        id="reset-email"
        v-model="email"
        :label="emailLabel"
        rules="required|email"
        name="userEmail"
        :trim="true" />
      <qx-button
        id="forgot-pass"
        :title="sendButtonLabel"
        :is-block="true"
        :in-progress="inProgress"
        type="submit"
        state="active" />
    </valid-form>
    <div
      v-translate
      class="qx-link"
      @click="toLogin">
      Back to login
    </div>
  </login-wrap>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { Form as ValidForm } from 'vee-validate';

import LoginWrap from '@/components/auth/LoginWrap.vue';
import QxInputRow from '@/elements/QxInputRow.vue';
import QxButton from '@/elements/button.vue';
import EventBus from '@/elements/eventBus.js';

import { logErrorWithSentry } from '@/elements/utils.js';
import { PASSWORD_CODE } from '@/utils/cons';
import { requestPasswordReset } from '@/api';

export default {
  name: 'ForgotPassword',
  components: {
    LoginWrap,
    QxInputRow,
    QxButton,
    ValidForm,
  },
  emits: ['success'],
  data() {
    return {
      inProgress: false,
      email: '',
      title: this.$gettext('Forgot password'),
      text:
        this.$gettext(
          "Enter your email address below and if you have an account we'll send an email with instructions on how to reset your password"
        ) + '.',
      emailLabel: this.$gettext('Email'),
      sendButtonLabel: this.$gettext('Send'),
    };
  },
  computed: {
    ...mapState({
      forcedMfaCode: (state) => state.auth.forcedMfaCode,
    }),
  },
  methods: {
    ...mapMutations({
      setMfaCode: 'auth/setMfaCode',
      setForcedMfaCode: 'auth/setForcedMfaCode',
    }),
    async sendAction() {
      if (this.inProgress) {
        return;
      }
      try {
        this.inProgress = true;
        const resetEmail = this.email.toLowerCase();
        await requestPasswordReset([resetEmail]);
        this.$notify({
          text: this.$gettext(
            'Check your mail, if we found your email address in our database we just sent password reset instructions.'
          ),
          type: 'notice',
        });
        this.$emit('success');
      } catch (error) {
        EventBus.$emit('handle-error', { response: error?.response });
        logErrorWithSentry(error);
      } finally {
        this.inProgress = false;
      }
    },
    toLogin() {
      if (this.forcedMfaCode) {
        this.setForcedMfaCode(null);
      } else {
        this.setMfaCode(PASSWORD_CODE);
      }
    },
  },
};
</script>
